import { DID, DID_CLASS, DID_STATUS, DID_TYPE, DidProvider, OrderDidRequest } from 'voxloud-types/dist/models';

export const NO_PROVIDER: DidProvider = {
  enabled: true,
  id: -1,
  name: "NONE",
  priority: -1
}


export class Address {
  city: string;
  country_code: string;
  id: number;
  state: string;
  street_name: string;
  street_number: string;
  zip_code: string;
}


export class VerificationData {
  id?: number;
  address: Address;
  company_id: number;
  company_name: string;
  country_code: string;
  documents: any[];
  first_name: string;
  last_name: string;
  tax_number: string;
  type: string;
  phone_number: string;
  description: string;
  email: string;
  birth_date: string;
  birth_place: string;
  nationality: string;
  label: string;
  _isDeleting?: boolean;
}


export interface FilterModel {
  name: string;
  type: string;
  data?: any;
  isLocked: boolean;
}

export interface LockedFilterModel {
  name: string;
  value: any;
}

export interface FiltersEmitModel {
  area_code?: string;
  company_id?: number;
  class?: DID_CLASS;
  country_code?: string;
  creation_date_from?: string;
  creation_date_to?: string;
  provider?: string;
  status?: DID_STATUS;
  type?: DID_TYPE;
  is_from_pool?: boolean;
}

export interface PortabilityRequestDto {
  id: string;
  company_id: string;
  dids: PortabilityRequestNumber[];
  documents: PortabilityRequestDocuments[];
  status: PORTABILITY_STATUS;
  creation_date: string;
  update_date: string;
}

export interface PortabilityRequestNumber {
  type: DID_TYPE;
  class: DID_CLASS;
  number: string;
}

export interface PortabilityRequestDocuments {
  documentType: string;
  documentUrl: string;
  id: number;
}

export enum PORTABILITY_STATUS {
  ONGOING = 'ONGOING',
  COMPLETED = 'COMPLETED'
}

export interface OrderDidManuallyRequest extends OrderDidRequest {
  company_id: number;
}

export interface OrderDidManuallyResponse {
  id: number;
  company_id: number;
  status: DID_STATUS;
  did: DID;
}

export interface AddDidManuallyRequest {
  number: string;
  company_id: number;
  provider: string;
  class: DID_CLASS;
  type: DID_TYPE;
  status?: DID_STATUS;
  provider_reference?: string;
  is_from_pool?: boolean;
  source_verification_data_id?: number;
  verification_data_id?: number;
}

export interface AddTestingDidManuallyRequest {
  number: string;
  company_id: number;
  provider: string;
  class: DID_CLASS;
  type: DID_TYPE;
  status: DID_STATUS.UNDER_TESTING;
  provider_reference?: string;
  is_from_pool?: boolean;
  source_verification_data_id?: number;
  verification_data_id?: number;
}
